import React, { FunctionComponent } from 'react';
import {Question} from '../../../../utils/University';
import HanTable, {
    HanTableCell,
    HanTableContainer,
    HanTableHead,
    HanTableRow
} from '../../../utils/han-table-components/HanTable';

interface Props {
    question: Question;
}

const QuestionTable: FunctionComponent<Props> = ({ question }) => {
    switch(question.question_type) {
        case 'open':
            return (
                <HanTableContainer>
                    <HanTableHead>
                        { question.question }
                    </HanTableHead>
                    
                    <HanTable className='han-table__table' modifiers={['wrap']}>
                        { question.answers.values.map((answer, index) => (
                            <HanTableRow
                                modifiers={index % 2 === 0 ? [] : ['alabaster']}
                                key={index}>
                                <HanTableCell>{answer}</HanTableCell>
                            </HanTableRow>
                        )) }
                    </HanTable>
                </HanTableContainer>
            );
        case 'open-with-number':
            return (
                <HanTableContainer>
                    <HanTableHead>
                        { question.question }
                    </HanTableHead>
                    
                    <HanTable className='han-table__table' modifiers={['wrap']} borderOrientation={'vertical'}>
                        { question.answers.values.map((answer, index) => (
                            <HanTableRow
                                modifiers={index % 2 === 0 ? [] : ['alabaster']}
                                key={index}>
                                <HanTableCell>{question.answers.labels[index]}</HanTableCell>
                                <HanTableCell>{answer}</HanTableCell>
                            </HanTableRow>
                        )) }
                    </HanTable>
                </HanTableContainer>
            );
        default:
            return (
                <HanTableContainer>
                    <HanTableHead>
                        { question.question }
                    </HanTableHead>

                    <HanTable borderOrientation={'vertical'}>
                        { (question.answers.labels.length > 0) &&
                            <HanTableRow>
                                { question.answers.labels.map(label => (
                                    <HanTableCell key={label}>{ label }</HanTableCell>
                                )) }
                            </HanTableRow>
                        }

                        <HanTableRow modifiers={['alabaster']}>
                            { question.answers.values.map((value, index) => (
                                <HanTableCell key={index}>{ value }</HanTableCell>
                            )) }
                        </HanTableRow>
                    </HanTable>
                </HanTableContainer>
            );
    }
};

export default QuestionTable;
